import React from "react";
import {Pressable, StyleProp, ViewStyle} from "react-native";
import MainStyle from "../../MainStyle";
import {AntDesign} from "@expo/vector-icons";
import {colors} from "../assets/styles/colors";
import {isFullSwing} from "../constants";
import Div from "../lib/Div";
import P from "../lib/P";

type Props = {
  children?: React.ReactNode, w?: number, onPress?: () => void, active?: boolean, dir?: string,
  style?: StyleProp<ViewStyle>, mr?: number
};

const Cell = (props: Props) => {
  const {children, w, active, dir, style, mr} = props;

  return (
    <Pressable onPress={props.onPress}
               style={[MainStyle.row, MainStyle.j_c_c, MainStyle.a_i_e, style, {width: w, marginRight: mr}]}>
      <P fw="500" fs={12} lh={12} color={active ? colors.newGreenText : 'white'}
         tt={isFullSwing ? 'uppercase' : undefined} flex={isFullSwing ? 1 : undefined}>
        {children}
      </P>

      {!isFullSwing && (
        <Div ml={2} mb={1}>
          <AntDesign
            name="caretup"
            size={4}
            color={active && dir === 'ascending' ? colors.newGreenText : 'white'}
            style={MainStyle.l_h_3_5}
          />
          <AntDesign
            name="caretdown"
            size={4}
            color={active && dir !== 'ascending' ? colors.newGreenText : 'white'}
            style={MainStyle.l_h_3_5}
          />
        </Div>
      )}
    </Pressable>
  );
};

export default React.memo(Cell);
